import type { InterpolationVars } from './types';

/**
 * Interpolates variables into a translation string.
 * Supports {variable} and {{variable}} syntax.
 */
export function interpolate(
  template: string,
  vars?: InterpolationVars
): string {
  if (!vars || Object.keys(vars).length === 0) {
    return template;
  }

  return template.replace(/\{\{?(\w+)\}?\}/g, (match, key) => {
    const value = vars[key];
    return value !== undefined ? String(value) : match;
  });
}


